export default "__VITE_ASSET__d6690509__"